// @ts-nocheck
import * as React from 'react';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import OurStory from '../components/OurStory';
import Itinerary from '../components/Itinerary';
import DressCode from '../components/DressCode';
import FlowerDivider from '../components/FlowerDivider';
import RSVP from '../components/RSVP';
import Gallery from '../components/Gallery';
import GiftRegistry from '../components/GiftRegistry';
import Footer from '../components/Footer';
import LoadingScreen from '../components/LoadingScreen';
import BotanicalBackground from '../components/BotanicalBackground';
import { preloadCriticalImages } from '../utils/imageLoader';
import ParallaxImage from '../components/ParallaxImage';

// @ts-ignore
const Index = () => {
  const [pageLoaded, setPageLoaded] = React.useState(false);
  
  React.useEffect(() => {
    // Preload critical images and mark as loaded
    preloadCriticalImages().finally(() => {
      setPageLoaded(true);
      
      // Handle hash navigation after page is loaded
      setTimeout(() => {
        const hash = window.location.hash.replace('#', '');
        if (hash) {
          const element = document.getElementById(hash);
          if (element) {
            const yOffset = -80; // Navbar height + padding
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }
      }, 500); // Small delay to ensure all components are rendered
    });
    
    // Intersection Observer for animation on scroll
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      
      elements.forEach((element) => {
        observer.observe(element);
      });
      
      return observer;
    };
    
    const observer = animateOnScroll();
    
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  // @ts-ignore
  return (
    <div className="relative min-h-screen flex flex-col overflow-hidden">
      {!pageLoaded && <LoadingScreen />}
      
      {/* Navbar al principio, antes del Hero para que sea visible */}
      <Navbar />
      
      <div className="flex-grow flex flex-col">
        {/* Hero sin fondo de BotanicalBackground */}
        <Hero />
        
        {/* BotanicalBackground global para toda la página excepto el Hero */}
        <div className="relative">
          <BotanicalBackground section="main" />
          
          <div className="relative z-10">
            {/* Componente Our Story - Ahora está justo después del Hero */}
            <OurStory />
            
            {/* Imagen decorativa con Parallax - Ahora usa el componente compatible con iOS */}
            <ParallaxImage 
              src="/lovable-uploads/fotoemi.jpg"
              className="my-4 md:my-20 mx-4 md:mx-12 z-0"
              overlayClass="bg-white/5 backdrop-blur-[1px]"
            />
            
            {/* Sección de detalles-inicio ahora usa el fondo global */}
            <section id="detalles-inicio" className="relative py-20 px-4">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-4xl md:text-5xl font-parisienne text-forest mb-6">Con el amor y apoyo de nuestros padres empezaremos esta aventura y queremos celebrarlo contigo.</h2>
                <div className="w-24 h-0.5 bg-sage/30 mx-auto mb-12"></div>
                
                {/* Padres de la pareja */}
                <div className="mb-20 bg-cream/70 backdrop-blur-sm rounded-xl p-12 shadow-lg transform hover:scale-[1.01] transition-transform duration-300">
                  <div className="grid md:grid-cols-2 gap-16">
                    <div className="text-center">
                      <h3 className="text-2xl font-baskerville text-forest mb-6">Padres de la novia</h3>
                      <p className="font-baskerville text-forest/80 mb-2 text-lg">Rodrigo Larrea Alarcón</p>
                      <p className="font-baskerville text-forest/80 text-lg">Gina Jácome Landeta</p>
                    </div>
                    
                    <div className="text-center"> 
                      <h3 className="text-2xl font-baskerville text-forest mb-6">Padres del novio</h3>
                      <p className="font-baskerville text-forest/80 mb-2 text-lg">Carlos Morochz Santos</p>
                      <p className="font-baskerville text-forest/80 text-lg">Lina Rosa Andrade Torres</p>
                    </div>
                  </div>
                </div>
                
                {/* Detalles del evento */}
                <div className="mt-16 grid md:grid-cols-2 gap-12">
                  <div className="bg-sage backdrop-blur-sm rounded-xl shadow-md p-12 flex flex-col items-center transform hover:scale-[1.01] transition-transform duration-300">
                    <h3 className="text-3xl font-baskerville text-forest mb-6">Ceremonia</h3>
                    <p className="text-forest/90 mb-4 text-lg font-baskerville">Sábado, 16 de agosto 2025</p>
                    <p className="text-forest/90 mb-4 text-lg font-baskerville">14:00 horas</p>
                    <p className="text-forest/90 font-semibold mb-3 text-xl font-baskerville">Iglesia Santiago Apóstol</p>
                    <p className="text-forest/90 mb-8 text-lg font-baskerville">Puembo, Ecuador</p>
                    <a 
                      href="https://maps.app.goo.gl/hUiogjzy3nvwcez86" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-forest border-b-2 border-forest/40 hover:border-forest transition-colors text-base py-1 font-baskerville"
                    >
                      Ver ubicación
                    </a>
                  </div>
                  
                  <div className="bg-sage backdrop-blur-sm rounded-xl shadow-md p-12 flex flex-col items-center transform hover:scale-[1.01] transition-transform duration-300">
                    <h3 className="text-3xl font-baskerville text-forest mb-6">Recepción</h3>
                    <p className="text-forest/90 mb-4 text-lg font-baskerville">Sábado, 16 de agosto 2025</p>
                    <p className="text-forest/90 mb-4 text-lg font-baskerville">16:00 horas</p>
                    <p className="text-forest/90 font-semibold mb-3 text-xl font-baskerville">Villa Pietra</p>
                    <p className="text-forest/90 mb-8 text-lg font-baskerville">Puembo, Ecuador</p>
                    
                    <a 
                      href="https://maps.app.goo.gl/YHgGbihq7H8R8Fir8" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-forest border-b-2 border-forest/40 hover:border-forest transition-colors text-base py-1 font-baskerville"
                    >
                      Ver ubicación
                    </a>
                  </div>
                </div>
              </div>
            </section>
            
            {/* Componente de Itineario */}
            <Itinerary 
              titleFont="parisienne"
              eventTitleFont="baskerville" 
              eventTextFont="baskerville"
            />
            
            {/* Componente de Código de Vestimenta */}
            <DressCode 
              titleFont="parisienne"
              headingFont="baskerville" 
              textFont="baskerville"
            />
            
            {/* Divisor floral después del Código de Vestimenta */}
            <FlowerDivider />

            {/* Sección RSVP con fondo transparente */}
            <RSVP />
            
            {/* Componente de Galería */}
            <Gallery />
            
            {/* Sección GiftRegistry con fondo transparente */}
            <GiftRegistry />
          </div>
        </div>
        
        {/* Degradado para conectar con el footer */}
        <div className="h-10 bg-gradient-to-b from-transparent to-forest"></div>
      </div>
      
      {/* Footer fuera del contenido principal */}
      <Footer />
    </div>
  );
};

export default Index;
